export const MOOP_PHASE_II_FLAG = 'moop-phase-ii' as const;

export const FEATURE_NAMES = {
  MOOP_PHASE_II: MOOP_PHASE_II_FLAG,
} as const;

export type FeatureName = (typeof FEATURE_NAMES)[keyof typeof FEATURE_NAMES];
